import { useState } from "react";

function SignIn(){
    const [tab,setTab] = useState(0);

    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("example@gmail.com");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [otp, setOtp] = useState("");

    const handleClicTab = (index) => {
        setTab(index);
      }

    return(
        <>
        <div className="page-content">
  <div className="form-v8-content">
    <div className="form-left">
      <img src="https://th.bing.com/th/id/OIP.ao1ND97U6vIHbDaCXQSb0wHaEK?rs=1&pid=ImgDetMain" alt="form" />
    </div>
    <div className="form-right">
      <div className="tab">
        <div className="tab-inner">
          <button
            className={`tablinks ${tab === 0? 'active':''}`}
            onClick={() => handleClicTab(0)}
          >
            Đăng ký
          </button>
        </div>
        <div className="tab-inner">
          <button
            className={`tablinks ${tab === 1? 'active':''}`}
            onClick={() => handleClicTab(1)}
          >
            Đăng nhập
          </button>
        </div>
      </div>
      <form className="form-detail">
        <div className="tabcontent" style={{ display: `${tab === 0?'block':'none'}` }}>
          <div className="form-row">
            <label className="form-row-inner">
              <input
                type="text"
                name="full_name"
                id="full_name"
                className="input-text"
                required=""
              />
              <span className="label">Họ và tên</span>
              <span className="border" />
            </label>
          </div>
          <div className="form-row">
            <label className="form-row-inner">
              <input
                type="text"
                name="full_name"
                id="full_name"
                className="input-text"
                required=""
              />
              <span className="label">Số điện thoại</span>
              <span className="border" />
            </label>
          </div>
          <div className="form-row">
            <label className="form-row-inner">
              <input
                type="text"
                name="your_email"
                id="your_email"
                className="input-text"
                required=""
              />
              <span className="label">E-Mail</span>
              <span className="border" />
            </label>
          </div>
          <div className="form-row">
            <label className="form-row-inner">
              <input
                type="password"
                name="password"
                id="password"
                className="input-text"
                required=""
              />
              <span className="label">Mật khẩu</span>
              <span className="border" />
            </label>
          </div>
          <div className="form-row">
            <label className="form-row-inner">
              <input
                type="password"
                name="comfirm_password"
                id="comfirm_password"
                className="input-text"
                required=""
              />
              <span className="label">Nhập lại mật khẩu</span>
              <span className="border" />
            </label>
          </div>
          <div className="form-col">
            <label className="form-col-inner">
              <input
                type="text"
                name="full_name"
                id="full_name"
                className="input-text"
                required=""
                placeholder="OTP"
                style={{ width: '95%'}}
              />
              <span className="border" />
            </label>
            <button style={{ width: '30%', backgroundColor: '#4CAF50', color: 'white', border: '2px solid #3e8e41', borderRadius: '8px' }}>Lấy OTP</button>
          </div>
          <p>fsdaf</p>
          <div className="form-row-last">
            <input
              type="submit"
              name="register"
              className="register"
              defaultValue="Register"
            />
          </div>
        </div>
      </form>
      <form className="form-detail">
        <div className="tabcontent" style={{ display: `${tab === 1?'block':'none'}` }}>
          <div className="form-row">
            <label className="form-row-inner">
              <input
                type="text"
                name="full_name_1"
                id="full_name_1"
                className="input-text"
                required=""
              />
              <span className="label">Username</span>
              <span className="border" />
            </label>
          </div>
          <div className="form-row">
            <label className="form-row-inner">
              <input
                type="text"
                name="your_email_1"
                id="your_email_1"
                className="input-text"
                required=""
              />
              <span className="label">E-Mail</span>
              <span className="border" />
            </label>
          </div>
          <div className="form-row">
            <label className="form-row-inner">
              <input
                type="password"
                name="password_1"
                id="password_1"
                className="input-text"
                required=""
              />
              <span className="label">Password</span>
              <span className="border" />
            </label>
          </div>
          <div className="form-row">
            <label className="form-row-inner">
              <input
                type="password"
                name="comfirm_password_1"
                id="comfirm_password_1"
                className="input-text"
                required=""
              />
              <span className="label">Comfirm Password</span>
              <span className="border" />
            </label>
          </div>
          <div className="form-row-last">
            <input
              type="submit"
              name="register"
              className="register"
              defaultValue="Sign In"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

        
        
        </>
    )
}

export default SignIn;